import axios from 'axios';

export const triggerBlobDownload = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
};

export const getAxiosErrorUserMessage = async (err: unknown, fallback: string): Promise<string> => {
  if (!axios.isAxiosError(err)) return fallback;
  const { response } = err;
  if (!response?.data) return fallback;
  const { data } = response;
  if (data instanceof Blob) {
    try {
      const text = await data.text();
      const parsed = JSON.parse(text) as { detail?: unknown };
      if (parsed.detail != null && String(parsed.detail).trim() !== '') return String(parsed.detail);
    } catch {
      return fallback;
    }
    return fallback;
  }
  if (typeof data === 'object' && data !== null && 'detail' in data) {
    const { detail } = data as { detail: unknown };
    if (detail != null && String(detail).trim() !== '') return String(detail);
  }
  return fallback;
};
